import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { type SessionDto, sessionDtoSchema } from '../schemas/sessionSchemas';
import { sessionKeys } from './sessionKeys';

// Resends the invite email for a session (a reminder). The backend re-issues the
// link if it has expired, so the returned session may carry a fresh publicToken.
export function useResendSession() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: async (sessionId: string): Promise<SessionDto> => {
      const raw = await apiClient.post(`api/v1/t/${tenantId}/sessions/${sessionId}/resend`).json();
      return sessionDtoSchema.parse(raw);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: sessionKeys.lists() });
    },
  });
}
